import { defineStore } from "pinia";
import { ISetPreviewParams } from "types/Preview/Preview";

interface State {
  previewSize: string | "100%" | "375px";
  previewMode: boolean;
  previewHTML: string | null;
  testingEmailAddresses?: string[];
  testingAddressesLocalStorage: boolean;
  enableImageToTextRatio?: boolean;
  isRatioLoading?: boolean;
  iframeIsLoading: boolean;
  enableTemplateSizeInfo?: boolean;
  enableDarkMode?: boolean;
  params?: ISetPreviewParams;
  darkMode?: boolean;
}

export const usePreviewStore = defineStore("preview", {
  state: (): State => ({
    previewSize: "100%",
    previewMode: false,
    previewHTML: null,
    enableImageToTextRatio: false,
    isRatioLoading: false,
    iframeIsLoading: false,
    enableTemplateSizeInfo: false,
    testingAddressesLocalStorage: true,
    enableDarkMode: false,
    darkMode: false,
  }),

  actions: {
    tooglePreviewMode() {
      if (!this.previewMode) {
        this.previewMode = true;
      } else {
        this.previewMode = false;
        const message = {
          type: "callback",
          action: "onPreviewClose",
          data: {
            args: [],
          },
        };
        window.parent.postMessage(JSON.parse(JSON.stringify(message)), "*");
      }
    },

    setEnableImageToTextRatio(val: boolean) {
      this.enableImageToTextRatio = val;
    },

    setEnableTemplateSizeInfo(val: boolean) {
      this.enableTemplateSizeInfo = val;
    },

    setPreviewSize(size: string) {
      this.previewSize = size;
    },

    setPreviewMode(mode: boolean) {
      this.previewMode = mode;
    },

    setPreviewHtml(html: string | null) {
      this.previewHTML = html;
      window.$event.emit("setHtml");
    },
  },
});
